var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.788,
    height: 13.887,
    viewBox: "0 0 16.788 13.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_edit_small_s",
    d: "M3,9.7H13.184v1.852H3ZM3,7.852H13.184V6H3Zm0,7.407H9.481V13.407H3Zm13.9-2.9.657-.657a.922.922,0,0,1,1.305,0l.657.657a.922.922,0,0,1,0,1.305l-.657.657Zm-.657.657-4.907,4.907v1.963H13.3L18.2,14.981Z",
    transform: "translate(-3 -6)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditS);
export default __webpack_public_path__ + "static/media/icon_edit_s.fd222f7986685de36e938d9fa01ade12.svg";
export { ForwardRef as ReactComponent };